import script from "./SearchBySearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBySearch.vue?vue&type=script&setup=true&lang=js"

import "./SearchBySearch.vue?vue&type=style&index=0&id=30386bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30386bf2"]])

export default __exports__